<template>
  <div class="header">
    <div class="content shadow">
      <div class="inner" style="grid-template-columns:1fr 1fr 1fr;">
        <div class="logo">
          <a href="https://www.musoonclinic.com.tw">
            <img class="mobile" src="@/assets/images/logo_s.svg" width="20" />
            <img class="pc" src="@/assets/images/logo_musoon.svg" width="164" />
          </a>
        </div>
        <div class="text">
          <p>{{ title }}</p>
        </div>
        <div
          class="text"
          style="justify-content: flex-end;"
          v-if="btnAppointment"
        >
          <!--<div
            class="btnAppointment"
            @click.prevent="$router.replace('/guest/web/AppointmentWebQuery')"
          >
            查詢、取消預約
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["title"],
  computed: {
    member() {
      return this.$store.state.member;
    },
    btnAppointment() {
      return (
        this.member.params.platform === "web" &&
        this.member.params.page === "Appointment"
      );
    }
  }
};
</script>

<style scoped>
.btnAppointment {
  border: 1px solid #f19e4e;
  border-radius: 100rem;
  padding: 6px 12px;
  background: #f19e4e;
  color: #fff !important;
  cursor: pointer;
  font-size: 12px;
}
</style>
